export default __webpack_public_path__ + "static/media/professional.fd99f5b0.png";